import { Box, BoxProps, styled } from '@mui/material';

import CancelSvgIcon from '../../assets/svg/task-status/CancelSvgIcon';
import FailSvgIcon from '../../assets/svg/task-status/FailSvgIcon';
import LoadingTaskIcon from '../../assets/svg/task-status/LoadingTaskIcon';
import SuccesssSvgIcon from '../../assets/svg/task-status/SuccessSvgIcon';
import { TaskStatus } from '../../types';
import PendingSvgIcon from '../../assets/svg/task-status/PendingSvgIcon';

interface ContainerProps {
  status: TaskStatus;
}

const Container = styled(Box)<ContainerProps>`
  display: inline-flex;
  align-items: center;
  color: ${({ status, theme }) => {
    switch (status) {
      case 'inProgress':
        return theme.color.primary.$100;
      case 'completed':
        return theme.color.green.$100;
      case 'failed':
        return theme.color.highlight;
      case 'canceled':
      default:
        return 'inherit';
    }
  }};

  & .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    & > * {
      display: block;
    }
  }
`;

interface TaskStatusIconProps extends BoxProps {
  status: TaskStatus;
}

const TaskStatusIcon: React.FC<TaskStatusIconProps> = ({
  status,
  ...otherProps
}) => {
  let statusIcon;

  switch (status) {
    case 'inProgress':
      statusIcon = <LoadingTaskIcon />;
      break;
    case 'canceled':
      statusIcon = <CancelSvgIcon />;
      break;
    case 'completed':
      statusIcon = <SuccesssSvgIcon />;
      break;
    case 'failed':
      statusIcon = <FailSvgIcon />;
      break;
    case 'pending':
      statusIcon = <PendingSvgIcon />;
      break;
  }

  return (
    <Container status={status} {...otherProps}>
      <div className="icon-container">{statusIcon}</div>
    </Container>
  );
};

export default TaskStatusIcon;
